export default class XScrollTranslator
{
    #callback;
    #breakpoints = [];

    constructor(callback)
    {
        this.#callback = callback;
    }

    reset()
    {
        this.#breakpoints = [];
    };

    addBreakpoint(souce, target, userData)
    {
        this.#breakpoints.push([souce, target, userData]);
    };

    onScroll(position)
    {
        if(this.#breakpoints.length == 0)
        {
            return;
        }
        if(position <= this.#breakpoints[0][0])
        {
            const breakpoint = this.#breakpoints[0];
            this.#callback(breakpoint[1], breakpoint[2], position, 0.0, -1);
            return;
        }
        else if(position >= this.#breakpoints[this.#breakpoints.length-1][0])
        {
            const breakpoint = this.#breakpoints[this.#breakpoints.length-1];
            this.#callback(breakpoint[1], breakpoint[2], position, 1.0, 1);
            return;
        }
        for(let i = 1; i < this.#breakpoints.length; i++)
        {
            const breakpoint = this.#breakpoints[i];
            if(position <= breakpoint[0])
            {
                const previousBreakpoint = this.#breakpoints[i-1];
                const t = (position - previousBreakpoint[0]) / (breakpoint[0] - previousBreakpoint[0]);
                this.#callback(previousBreakpoint[1] + t * (breakpoint[1] - previousBreakpoint[1]), previousBreakpoint[2], position, t, 0);
                return;
            }
        }
    };
}
